var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(this.$route.name !== 'login')?_c('appHeader'):_vm._e(),_c('router-view'),_c('vue-snotify'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chrome-font-fix"},[_vm._v("cц"),_c('b',[_vm._v("cц")]),_c('i',[_vm._v("cц")])])
}]

export { render, staticRenderFns }